import React from "react";
import "./PageHero.css";

function PageHero({
  badge,
  title,
  description,
  backgroundImage,
  primaryButtonText,
  primaryButtonLink,
  secondaryButtonText,
  secondaryButtonLink,
}) {
  return (
    <section
      className="page-hero"
      style={{
        background: `
          linear-gradient(
            rgba(15, 23, 42, 0.75),
            rgba(15, 23, 42, 0.75)
          ),
          url(${backgroundImage}) center/cover no-repeat
        `,
      }}
    >
      <div className="container">
        <div className="page-hero-content">
          {/* <span className="page-hero-badge">
            {badge}
          </span> */}

          <h1 className="page-hero-title">{title}</h1>

          <p className="page-hero-description">{description}</p>

          <div className="page-hero-buttons">
            {primaryButtonText && (
              <a
                href={primaryButtonLink}
                target="_blank"
                rel="noopener noreferrer"
                className="btn page-whatsapp-btn"
              >
                {primaryButtonText}
              </a>
            )}

            {secondaryButtonText && (
              <a href={secondaryButtonLink} className="btn page-call-btn">
                {secondaryButtonText}
              </a>
            )}
          </div>
        </div>
      </div>
    </section>
  );
}

export default PageHero;
